const TRANSFER_POLICY_TEXT = Object.freeze({
  allTransfers: 'SELF_EMPLOYED_ALL_TRANSFERS',
  splitCommissions: 'SELF_EMPLOYED_SPLIT_COMMISSIONS', // ? TBD missing
  tipOnly: 'EMPLOYED_TIP_ONLY',
  noTransfer: 'NO_TRANSFERS',
});

// noinspection JSUnusedGlobalSymbols
export default TRANSFER_POLICY_TEXT;
